// Marco común del panel autenticado: sidebar vertical fijo a la izquierda
// (marca + navegación + usuario/salir) y el contenido a la derecha.
import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from './auth.js';
import { ROL_LABEL } from './api.js';

export function Layout({ children }: { children: ReactNode }) {
  const { user, logout } = useAuth();
  const linkClass = ({ isActive }: { isActive: boolean }) =>
    isActive ? 'sb-link active' : 'sb-link';

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="sidebar-brand">
          Satfilters <span>Dimensionado</span>
        </div>

        {user && (
          <nav className="sidebar-nav">
            <NavLink to="/fichas" className={linkClass}>
              <span className="ic">📋</span> Fichas
            </NavLink>
            {user.rol === 'admin' && (
              <NavLink to="/usuarios" className={linkClass}>
                <span className="ic">👥</span> Usuarios
              </NavLink>
            )}
            {user.rol === 'admin' && (
              <NavLink to="/configuracion" className={linkClass}>
                <span className="ic">⚙️</span> Configuración
              </NavLink>
            )}
          </nav>
        )}

        {user && (
          <div className="sidebar-footer">
            <NavLink to="/perfil" className="sb-user">
              <strong>{user.nombre}</strong>
              <span className="rol">{ROL_LABEL[user.rol]}</span>
            </NavLink>
            <button className="btn-ghost" onClick={() => void logout()}>
              Salir
            </button>
          </div>
        )}
      </aside>

      <main className="content">{children}</main>
    </div>
  );
}
